interface CartDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  count: number;
}

export default function CartDrawer({ isOpen, onClose, count }: CartDrawerProps) {
  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-[90]">
          <div className="absolute inset-0 bg-black/40" onClick={onClose}></div>
          <div className="absolute right-0 top-0 bottom-0 w-full max-w-sm bg-white flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
              <h3 className="font-bold text-gray-900 text-lg">
                购物车 <span className="text-red-500 text-sm font-normal">({count} 件)</span>
              </h3>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full cursor-pointer transition-colors">
                <i className="ri-close-line text-lg text-gray-500"></i>
              </button>
            </div>

            {/* Empty state */}
            {count === 0 ? (
              <div className="flex-1 flex flex-col items-center justify-center text-center px-6">
                <div className="w-20 h-20 flex items-center justify-center bg-red-50 rounded-full mb-4">
                  <i className="ri-shopping-cart-line text-4xl text-red-300"></i>
                </div>
                <p className="text-gray-500 font-medium mb-1">购物车还是空的</p>
                <p className="text-gray-400 text-sm mb-6">快去挑选你喜欢的商品吧！</p>
                <button
                  onClick={onClose}
                  className="bg-red-500 hover:bg-red-600 text-white px-8 py-2.5 rounded-xl font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  去购物
                </button>
              </div>
            ) : (
              <div className="flex-1 flex flex-col items-center justify-center text-center px-6">
                <div className="w-20 h-20 flex items-center justify-center bg-red-50 rounded-full mb-4">
                  <i className="ri-shopping-cart-line text-4xl text-red-400"></i>
                </div>
                <p className="text-gray-700 font-medium mb-1">已添加 {count} 件商品</p>
                <p className="text-gray-400 text-sm mb-6">登录后查看完整购物车</p>
                <button className="bg-red-500 hover:bg-red-600 text-white px-8 py-2.5 rounded-xl font-medium transition-colors cursor-pointer whitespace-nowrap">
                  去结算
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
